import script from "./OfferCompareRow.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferCompareRow.vue?vue&type=script&setup=true&lang=js"

import "./OfferCompareRow.vue?vue&type=style&index=0&id=736e5a0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-736e5a0e"]])

export default __exports__